import React from 'react';
import { ErrorState } from '@leagueplatform/web-common-components';
import { LeaderboardList } from '#components/leaderboard/leaderboard-list.component.tsx';
import { useGetTeamUserChallengeRanks } from '#pages/team-landing-page/hooks/use-get-team-user-challenge-ranks.hook.ts';
import { LeaderboardSkeletonLoader } from '#components/leaderboard/leaderboard-skeleton-loader.component.tsx';
import { EmptyActivityState } from '#components/empty-activity-state/empty-activity-state.component.tsx';
import { useIntl } from '@leagueplatform/locales';

export const TeamLeaderboard = () => {
  const { formatMessage } = useIntl();
  const teamUserChallengeRanksQuery = useGetTeamUserChallengeRanks();

  const flattenedTeamLeaderboardData =
    teamUserChallengeRanksQuery.data?.pages?.flatMap((p) => p.data);

  if (teamUserChallengeRanksQuery.isLoading) {
    return <LeaderboardSkeletonLoader />;
  }

  if (teamUserChallengeRanksQuery.error || !flattenedTeamLeaderboardData) {
    return <ErrorState error={teamUserChallengeRanksQuery.error} />;
  }

  if (flattenedTeamLeaderboardData.length === 0) {
    return (
      <EmptyActivityState
        activityDescription={formatMessage({
          id: 'NO_LEADERBOARD_ACTIVITY_DESCRIPTION',
        })}
      />
    );
  }

  return (
    <LeaderboardList
      leaderboardData={flattenedTeamLeaderboardData}
      leaderboardView="individual"
      displayViewMore={!!teamUserChallengeRanksQuery.hasNextPage}
      isFetchingNextPage={teamUserChallengeRanksQuery.isFetchingNextPage}
      fetchNextPage={teamUserChallengeRanksQuery.fetchNextPage}
    />
  );
};
